import http from '@/axios/http'
import { getuser_id, getclient_user_id, getgroup } from "@/localStorage/localStorage";

//实时报警列表

export function getRealtimeAlarmList() {
    const data = {
        offset: 1,
        limit: 10,
        user_id: getuser_id()
    }
    return http({
        url: '/api/alarm/getRealtimeAlarmList',
        method: 'post',
        data
    })
}